/**
 * 认证类型
 */
export enum AuthType {
  /**
   * 用户名/密码模式
   */
  Normal = 'e-n-p'
}

/**
 * 令牌类型
 */
export enum TokenType {
  /**
   * 用户名/密码模式
   */
  Normal = 'e-n-p'
}
